// src/api/queries/unifarmQueries.js
export const UNIFARM_CREATEDS_QUERY = `
  query GetUnifarmCreateds($skip: Int, $first: Int, $orderBy: UnifarmCreated_orderBy, $orderDirection: OrderDirection, $where: UnifarmCreated_filter) {
    unifarmCreateds(
      skip: $skip
      first: $first
      orderBy: $orderBy
      orderDirection: $orderDirection
      where: $where
    ) {
      id
      owner
      metadata
      transactionHash
      unifarm
      rewardToken
      duration
      rewardAmount
      # 👆 Add any fields you want from the entity
    }
  }
`;
export const POOL_CREATEDS_QUERY = `
  query GetPoolCreateds(
   
    $where: PoolCreated_filter,
  ) {
    unifarmCreateds(
     
      where: $where
    ) {
      id
owner
unifarm
rewardToken
rewardAmount
duration
metadata
blockNumber
blockTimestamp
transactionHash

    }
  }
`;
export const GET_MY_STAKES = `
  query GetMyStakes(
    $where: Staked_filter,
    $first: Int,
    $skip: Int
  ) {
    stakeds(
      where: $where,
      first: $first,
      skip: $skip,
      orderBy: blockTimestamp,
      orderDirection: desc
    ) {
      id
      staker
      amount
      claimTime
      blockNumber
      blockTimestamp
      contract
      transactionHash
    }
  }
`;
export const ALL_ROOT_POOLS = ` 
query GetPoolCreateds($skip: Int, $first: Int, $orderBy: UnifarmCreated_orderBy, $orderDirection: OrderDirection) {
    unifarmCreateds(
      skip: $skip
      first: $first
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      id
      owner
      metadata
      transactionHash
      unifarm
      rewardToken
      rewardAmount
    }
  }
`

export const CHILD_POOLS_QUERY = `
  query GetPoolCreateds(
   $orderDirection: OrderDirection
    $where: PoolCreated_filter,
  ) {
    poolCreateds(
     orderDirection: $orderDirection
      where: $where
    ) {
id
pool
contract
 creatorFee
bondAmount
blockNumber
blockTimestamp
transactionHash
metadata
    }
  }
`;

// profile page count queries
// NEW: Count queries (fetch only minimal data for counting)
export const CHILD_POOLS_COUNT_QUERY = `
  query GetPoolCreatedsCount($where: PoolCreated_filter) {
    poolCreateds(where: $where) {
      id
    }
  }
`;

export const ROOT_POOLS_COUNT_QUERY = `
  query GetUnifarmCreatedsCount($where: UnifarmCreated_filter) {
    unifarmCreateds(where: $where) {
      id
    }
  }
`;

// GraphQL query
export const ROOT_POOLS_COUNT_QUERY_PER_POOL = `
  query GetPoolCreatedsCount($contracts: [Bytes!]) {
    poolCreateds(where: { contract_in: $contracts }) {
      id
      contract
      pool
    }
  }
`;
// GraphQL query
export const ROOT_POOLS_DATA_THROUGH_CHILDPOOL = `
  query GetRootPool($pool: [Bytes!]) {
    unifarmCreateds(where: { unifarm_in: $pool }) {
     id
      owner
      metadata
      transactionHash
      unifarm
      rewardToken
      rewardAmount
    }
  }
`;

export const GLOBAL_STATS_QUERY = `
  query GetGlobalStats($skip: Int, $first: Int, $orderBy: GlobalStat_orderBy, $orderDirection: OrderDirection, $where: GlobalStat_filter) {
    globalStats(
      skip: $skip
      first: $first
      orderBy: $orderBy
      orderDirection: $orderDirection
      where: $where
    ) {
      TVL
      stakers
      farms
      pools
      
    }
  }
`;

export const ROOT_POOLS_TVL = `
  query GetRootPoolTvl($id: [Bytes!]) {
    poolTvls(where: { id_in: $id }) {
     id
      tvl
    }
  }`


// Fetch TVL for specific pools
export const POOL_TVL_QUERY = `
  query GetPoolTvl($where: PoolTvl_filter) {
    poolTvls(where: $where) {
      id
      tvl
    }
  }
`;

export const ACTIVITY_QUERY = `

  query GetActivity($where: StakeData_filter, $skip:Int, $first:Int,$orderBy:StakeData_orderBy,$orderDirection:OrderDirection) {
  stakeDatas(where:$where
   skip: $skip
      first: $first
      orderBy: $orderBy
      orderDirection: $orderDirection){
    amount
    blockTimestamp
    contract
    transactionHash
    type 
  }
}

`

export const UNSTAKE_REQUESTS_QUERY = `

query UnstakeRequested($where:UnstakeRequested_filter) {

  unstakeRequesteds(where:$where   
  skip: $skip
      first: $first
      orderBy: $orderBy
      orderDirection: $orderDirection){
    amount,
    staker,
    transactionHash,
    contract,
    blockTimestamp,
    claimTime,
    id
  }
}
`

export const STAKES = `
query Stakes($where:Stake_filter) {

  stakes(where:$where){
    amount,
    contract
  }
}
  `
  export const CLAIMABLE = `
query requestClaimeds($where:RequestClaimed_filter) {

  requestClaimeds(where:$where){
    amount,
    contract
  }
}
  `
export const  CLAIMEDS = `
query claimeds($where: Claimed_filter) {
  claimeds(where: $where) {
    reward
    contract
  }
}

  `
export const UNSTAKES = `query Unstakes($where:UnStake_filter) {

  unStakes(where:$where){
    totalUnstaked,    
  }
}`
